export default __webpack_public_path__ + "static/3blackdot-logo-white-ba5b19faea11f1b05ac1f7a961f39581.svg";